import { EarthIcon } from './EarthIcon';

/**
 * author: Google
 * id 0D1618BF-A3AD-4B4A-92EA-5DBF93BF7625
 * name earth
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/earth.svg
 * tags
 * - Geographic Information System 
 * - Navigation 
 */
export const GlobeIcon = EarthIcon;
export default GlobeIcon